/* eslint-disable camelcase */
import { useEffect, useState } from 'react';
import styles from './styles';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { Grid } from '@mui/material';
import columns from './table_config';
import PropTypes from 'prop-types';
import SelectEditInputTextField from '../../../ui/SelectEditInputTextField';
import Datagrid from '../../../ui/Datagrid';
import { isMobile } from 'react-device-detect';
import MobileCuttingsInput from '../../../mobile/hydraulics/featuredWellRunInputs/cuttingsRunInput';

const CuttingRunInputs = ({
  data,
  setUpdateCuttingData,
  invalidCuttingRows,
  setParameterDirty,
  loading,
  cuttingRunUnits
}) => {
  const classes = styles();
  const apiRef = useGridApiRef();
  const [properties, setProperties] = useState([]);

  function generateRandom() {
    const length = 24;
    const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let retVal = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  useEffect(() => {
    setProperties([{ _id: generateRandom(), ...data }]);
  }, [data]);

  useEffect(() => {
    if (properties[0]?.diameter === '') {
      const id = properties[0]._id;
      setTimeout(() => {
        apiRef.current.scrollToIndexes({
          rowIndex: 0
        });
        apiRef.current.setCellMode(id, 'diameter', 'edit');
        setTimeout(() => {
          apiRef.current.setCellFocus(id, 'diameter');
        }, 50);
      }, 50);
      apiRef.current.setPage(0);
    }
  }, [properties?.length]);

  const updateData = (id, field, value) => {
    setProperties(prevProperties => {
      const updatedProperties = prevProperties.map(item => {
        if (item._id === id) {
          const isDirty = value !== item[field];
          return {
            ...item,
            [field]: Number(value),
            isDirty
          };
        }
        return item;
      });
      return updatedProperties;
    });
    setUpdateCuttingData(prev => ({
      ...prev,
      [field]: value,
      _id: id
    }));
    setParameterDirty(prev => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;
      const updated = [...prev];
      updated[0] = { ...updated[0], isDirty: true };
      return updated;
    });
  };

  const renderValueCell = (params) => {
    return <SelectEditInputTextField numberFormatOnly {...params} updateData={updateData} />;
  };

  return (
    <>
      <Grid container maxWidth='1000px'>
        <Grid item xs={12}>
          {isMobile
            ? (
              <MobileCuttingsInput
                data={properties}
                columns={columns(renderValueCell, cuttingRunUnits)}
                updateData={updateData}
                loading={loading}
              />
              )
            : (
              <Datagrid
                apiRef={apiRef}
                data={properties}
                loading={loading}
                sx={{
                  marginLeft: '-6px',
                  '.MuiDataGrid-cell': {
                    fontSize: '1rem',
                    fontWeight: 900,
                    pointerEvents: loading ? 'none' : 'auto',
                    backgroundColor: loading ? '#f5f5f5' : 'inherit'
                  },
                  '.MuiDataGrid-columnHeader': {
                    fontSize: '1.2rem',
                    fontWeight: '900 !important'
                  },
                  '& .MuiDataGrid-footerContainer': {
                    display: 'none',
                  },
                }}
                columns={columns(renderValueCell, cuttingRunUnits)}
                onRowClick={(params, evt) => {
                  evt.preventDefault();
                  evt.stopPropagation();
                }}
                disableStickyHeader={false}
                autoHeight={false}
                autoheight
                height={'150px'}
                getRowClassName={(params) => {
                  return loading ? 'Mui-disabled' : (invalidCuttingRows[params.id] ? classes.invalidRow : '');
                }}
                pageSize={100}
                editMode="cell"
                toolbar={{
                  options: {
                    columns: false,
                    filters: false,
                    density: false,
                    export: false
                  },
                }}
              />
              )}
        </Grid>
      </Grid>
    </>
  );
};
CuttingRunInputs.propTypes = {
  data: PropTypes.any,
  setUpdateCuttingData: PropTypes.any,
  invalidCuttingRows: PropTypes.any,
  setParameterDirty: PropTypes.func,
  loading: PropTypes.bool,
  cuttingRunUnits: PropTypes.any
};

export default CuttingRunInputs;
